import React from 'react';
import PropTypes from 'prop-types';
import RenderAutoCompleteInputField from 'components/form/InputFields/RenderAutoCompleteInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { getComponentByResoureName, getFieldsByResourceName } from 'helpers/product';
import { reduxForm, change, getFormValues, isInvalid, Field, formValueSelector } from 'redux-form';
import client from 'http/client';
import { showNotification } from 'store/actions/uiActions';

class ProductResource extends React.Component {
    state = {
        choices: [],
    }

    componentDidMount() {
        const {
            data,
            initialize,
        } = this.props;

        this.fetchAvailableResources();

        if (!utils.isEmpty(data)) {
            initialize({
                id: data.id,
                name: data.name,
            });
        }
    }

    async fetchAvailableResources() {
        const { translate, showNotification } = this.props;

        try {
            const response = await client.get('/available-resources', {
                type: [
                    'product',
                ],
            });

            this.setState({
                choices: response.map((resource) => {
                    return {
                        ...resource,
                        name: resource.name.replace(/_|-/g, ' '),
                    };
                }),
            });
        } catch (error) {
            showNotification(translate('resources.products.messages.available_resources.failure'), 'error');
        }
    }

    render() {
        const {
            selectedResourceName,
            handleSubmit,
            handleSubmitForm,
            invalid,
            pristine,
            submitting,
            translate,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    choices={ this.state.choices }
                                    component={ RenderAutoCompleteInputField }
                                    label={ translate('resources.products.fields.resource.name') }
                                    maxSearchResults={ 6 }
                                    name='name'
                                    optionText='name'
                                    optionValue='id'
                                    resource='available-resources'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                        <Row>
                            <Item>
                                <Field
                                    component={ getComponentByResoureName(selectedResourceName) }
                                    fields={ getFieldsByResourceName(selectedResourceName) }
                                    fullWidth={ true }
                                    label={ translate('resources.products.fields.resource.id') }
                                    name='id'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ pristine || submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

ProductResource.propTypes = {
    data: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    selectedResourceName: PropTypes.string,
    showNotification: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    const selector = formValueSelector(form);

    return {
        formValues: getFormValues(form)(state),
        invalid: isInvalid(form)(state),
        selectedResourceName: selector(state, 'name'),
    };
};

const mapDispatchToProps = (dispatch, props) => {
    const {
        form,
    } = props;

    return {
        changeFieldValue: (field, value) => {
            dispatch(change(form, field, value));
        },
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.id) {
                errors.id = translate('forms.required');
            }

            if (!values.name) {
                errors.name = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(ProductResource);



// WEBPACK FOOTER //
// ./src/pages/products/resource/ProductResource.js